import {Component} from '@angular/core';
import {NavigationEnd, NavigationStart, Router, RouterEvent} from '@angular/router';

import * as $ from 'jquery';
import {ApiService} from './services/api.service';

@Component({
  selector: 'pm-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'QuickKicks Marketplace';

  constructor(
    private router: Router,
    private api: ApiService
  ) {
    this.router.events.subscribe((res: RouterEvent) => {
      if (res instanceof NavigationStart) {
        $('#status').show();
        $('#preloader').show();
      }
      if (res instanceof NavigationEnd) {
        this.updateNavFooter();
        setTimeout(() => {
          $('#status').fadeOut();
          $('#preloader').delay(100).fadeOut();
        }, 100);
      }
    });

    this.exampleApiCall();
  }

  updateNavFooter(): void {
    if ($(window).width() > 991) {
      const footerPadd = $('footer').height() + 'px';
      $('main').css('margin-bottom', footerPadd);
    }

    if ($(window).width() > 10) {
      const footerPadd = $('nav').height() + 'px';
      $('main').css('padding-top', footerPadd);
    }
  }

  private async exampleApiCall(): Promise<any> {
    try {
      const res = await this.api.getData();
      console.log(res);
    } catch (e) {
      console.error(e);
    }
  }
}
